// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.concierge-create-supplier-modal {
  max-width: 768px;
}
.concierge-create-supplier-modal .status-alert {
  margin-top: var(--spacing-small);
}
.concierge-create-supplier-modal .instructions span {
  font-weight: 700;
}
.concierge-create-supplier-modal .commentary-container {
  margin-top: var(--spacing-small);
}
.concierge-create-supplier-modal .input-group {
  margin-top: var(--spacing-small);
}
.concierge-create-supplier-modal .action-btn-container {
  margin-top: var(--spacing-regular);
  display: flex;
  gap: var(--spacing-extra-small);
}
.concierge-create-supplier-modal .action-btn-container .btn-confirm:not([disabled]).ant-btn-highlight {
  background-color: var(--color-highlight) !important;
}
.concierge-create-supplier-modal .action-btn-container .btn-confirm:not([disabled]).ant-btn-highlight:hover {
  background-color: var(--color-highlight-darker) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Concierge/Modals/CreateSupplierModal.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAFA;EAII,gCAAA;AACJ;AALA;EASM,gBAAA;AADN;AARA;EAcI,gCAAA;AAHJ;AAXA;EAkBI,gCAAA;AAJJ;AAdA;EAsBI,kCAAA;EAEA,aAAA;EACA,+BAAA;AANJ;AASM;EACE,mDAAA;AAPR;AAUM;EACE,0DAAA;AARR","sourcesContent":[".concierge-create-supplier-modal {\n  max-width: 768px;\n\n  .status-alert {\n    margin-top: var(--spacing-small);\n  }\n\n  .instructions {\n    span {\n      font-weight: 700;\n    }\n  }\n\n  .commentary-container {\n    margin-top: var(--spacing-small);\n  }\n\n  .input-group {\n    margin-top: var(--spacing-small);\n  }\n\n  .action-btn-container {\n    margin-top: var(--spacing-regular);\n\n    display: flex;\n    gap: var(--spacing-extra-small);\n\n    .btn-confirm:not([disabled]) {\n      &.ant-btn-highlight {\n        background-color: var(--color-highlight) !important;\n      }\n    \n      &.ant-btn-highlight:hover {\n        background-color: var(--color-highlight-darker) !important;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
